<template>
  <v-expansion-panels
    :variant="type"
    :class="`so-expansion-panels--${type}`"
    :multiple="type !== 'accordion'"
    data-testid="expansion-panels"
    class="rounded"
  >
    <slot></slot>
  </v-expansion-panels>
</template>

<script lang="ts">
  import { PropType } from "vue"
  import { defineComponent } from "vue"

  export default defineComponent({
    props: {
      type: {
        type: String as PropType<"accordion" | "default">,
        default: "default",
      },
    },
  })
</script>

<style>
  .so-expansion-panels--accordion .v-expansion-panel::after {
    display: none;
  }
</style>
